import { forwardRef } from 'react'
import { useController } from 'react-hook-form'

import type { ReactElement, ReactNode } from 'react'
import type { UseControllerProps } from 'react-hook-form'

import BasicCheckboxInput from '~/components/Inputs/Basic/CheckboxInput'

interface Props extends UseControllerProps<any> {
  className?: string
  disabled?: boolean
  label?: string
  labelPosition?: 'left' | 'right'
  name: string
  required?: boolean
  size?: Exclude<SIZES, 'large'>
  tooltip?: ReactNode
}

const CheckboxInput = forwardRef(({ className, ...props }: Props): ReactElement => {
  const { field } = useController(props)

  return (
    <div className={className}>
      <BasicCheckboxInput {...field} {...props} checked={field.value} />
    </div>
  )
})

CheckboxInput.displayName = 'CheckboxInput'

export default CheckboxInput
